import "./ContributionManagmentRow.scss";

// @vendors
import { connect } from 'react-redux';
import React from 'react';
const { withRouter } = require('react-router-dom');
import { PropTypes } from 'prop-types';

// @helpers
const { getLastNChars } = require('utilities/stringHelper');
const { formatDate } = require('utilities/dateHelper');
import { i18n } from 'core/i18n';
const { FormattedText } = i18n;

const {
    DATE_FORMAT_DAY_MONTH_YEAR
} = require('constants/index');

// @commons
import OKTableRowDetails from 'components/rebrand/OKTableRowDetails/OKTableRowDetails';
import OKTableRowDetailsItem from 'components/rebrand/OKTableRowDetails/OKTableRowDetailsItem/OKTableRowDetailsItem';
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCollapsingToggler } = require('commonsComponents/OKCollapsingToggler');

//@utils
const { PROC_BROKER_INVESTMENT_CONTRIBUTIONS } = require('utilities/tagging.js')
const { taggingEventHandled } = require('utilities/taggingEventHandled');

// @ actions
import BrokerPeriodicalFundsContributionsActions from 'actions/brokerPeriodicalFundsContributions';

const ContributionManagmentRow = ({
  data,
  index,
  handleRowClick,
  expandRowId,
  children,
  history,
  handlePeriodicalContributionSelected
}) => {
  const { marketable, isNewContribution, id, secId } = data;

  const buildDate = () => {
    const { subscriptionDate } = data;
    return  formatDate(
        subscriptionDate,
        DATE_FORMAT_DAY_MONTH_YEAR
      );
  }

  const buildDetails = data => {
    const { nextInstallmentDate, subscriptionDate, associatedAccount } = data;
    const last4ContractCode = getLastNChars(associatedAccount.numeroContrato, 4, '');
    let content;
    content = (
        <OKTableRowDetails title="broker-ordersAndMovementsActivityDetailsTitle">
            <OKTableRowDetailsItem title={'brokerWealth-contributionManagmentAssociateAccount'} value={`...${last4ContractCode}`} />
            <OKTableRowDetailsItem title={'brokerWealth-contributionManagmentNextContribution'} value={nextInstallmentDate ? nextInstallmentDate : '-'} />
            <OKTableRowDetailsItem title={'brokerWealth-contributionManagmentSubscriptionDate'} value={subscriptionDate ? buildDate() : '-'} />
        </OKTableRowDetails>
    );
    return content;
  };

  const handleCancelContribution = data => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'cancelContributionButton', {isin: data.isin, name: data.marketName});
    handlePeriodicalContributionSelected(data);
    history.push(`/myprofile/broker/contributionManagment/cancel/${data.productId}/${data.contractCode  }`);
  };

  const handleClickNewContribution = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'newContributionButton', {isin: data.isin, name: data.marketName});
    history.push(`/myprofile/broker/fundsPeriodicContribution/${secId}/${id}`);
  };
  const handleUpdateContribution = () => {
    taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'updateContributionButton', {isin: data.isin, name: data.marketName});
    history.push(`/myprofile/broker/fundsPeriodicContribution/${secId}/${id}`)
  };



  const details = buildDetails(data);

  return (
    <React.Fragment>
      <OKTableRow className="broker-contribution-managment-table-row" id={index}>
        <OKTableCell>
          {!isNewContribution && (
            <OKCollapsingToggler
              handlerToggle={() => handleRowClick(index)}
              isExpanded={index === expandRowId}
              isIconFixed
              isIconSecondary
            />
          )}
        </OKTableCell>
        {children}
        <OKTableCell>
          {isNewContribution ? (
            <section className="broker-contribution-managment-table-row__buttons-container-new">
              <OKButton
              id={index}
              modifier="secondary"
              disabled={!marketable}
              onClick={handleClickNewContribution}
              >
                <FormattedText value="brokerWealth-contributionManagmentNewContribution" />
              </OKButton>
            </section>
          ) : (
            <section className="broker-contribution-managment-table-row__buttons-container">
              <OKButton id={index} modifier="ghost" onClick={()=>handleCancelContribution(data)}>
                 <FormattedText value="brokerWealth-contributionManagmentCancelContribution" />
              </OKButton>
              <OKButton id={index} modifier="secondary" onClick={handleUpdateContribution}>
                 <FormattedText value="brokerWealth-contributionManagmentUpdateContribution" />
              </OKButton>
            </section>
          )}
        </OKTableCell>
      </OKTableRow>
      {index === expandRowId && (
        <OKTableRow className="broker-contribution-managment-table-row">
          <OKTableCell></OKTableCell>
          {details}
        </OKTableRow>
      )}
    </React.Fragment>
  );
};

ContributionManagmentRow.propTypes = {
  handleRowClick: PropTypes.func.isRequired,
  handlePeriodicalContributionSelected: PropTypes.func.isRequired,
};

export default connect(
    null,
    {
        handleRowClick: BrokerPeriodicalFundsContributionsActions.handleRowClick,
        handlePeriodicalContributionSelected: BrokerPeriodicalFundsContributionsActions.handlePeriodicalContributionSelected,
    }
)(withRouter(ContributionManagmentRow));
